import React from 'react'
import { Box, TableCell } from '@mui/material'
import { ui, tone } from '../../utils/uiTokens'
import { LEVEL_COLORS } from '../curator/ratingPage/ratingLevel'

export const TONE = {
    good: LEVEL_COLORS.green,
    warn: LEVEL_COLORS.yellow,
    bad: LEVEL_COLORS.red,
    mute: { ...tone.neutral, accent: tone.neutral.text },
    info: { ...tone.info, accent: tone.info.text },
}

export type Tone = keyof typeof TONE

export const toneOf = (v: number, good: number, warn: number): Tone => (v >= good ? 'good' : v >= warn ? 'warn' : 'bad')

export const Pill: React.FC<{ tone: Tone; children: React.ReactNode; title?: string }> = ({ tone, children, title }) => (
    <Box
        component="span"
        title={title}
        sx={{
            display: 'inline-block',
            padding: '2px 9px',
            borderRadius: '100px',
            fontSize: '12px',
            fontWeight: 700,
            whiteSpace: 'nowrap',
            background: TONE[tone].bg,
            color: TONE[tone].text,
            border: `1px solid ${TONE[tone].border}`,
        }}
    >
        {children}
    </Box>
)

export const PctPill: React.FC<{ value: number | null | undefined; good: number; warn: number }> = ({ value, good, warn }) => (
    <Pill tone={toneOf(value ?? 0, good, warn)}>{Math.round(value ?? 0)}%</Pill>
)

export const Kpi: React.FC<{ label: string; value: React.ReactNode; hint?: React.ReactNode; dark?: boolean; color?: string }> = ({
    label,
    value,
    hint,
    dark,
    color,
}) => (
    <Box sx={{ borderRadius: '16px', padding: '16px 18px', background: dark ? ui.pinkSoft : ui.card, border: `1px solid ${dark ? ui.pinkSoft : ui.border}` }}>
        <Box sx={{ fontSize: '12.5px', color: dark ? ui.pinkDark : ui.sub }}>{label}</Box>
        <Box sx={{ fontSize: '26px', fontWeight: 800, color: dark ? ui.pinkDark : color ?? ui.ink, marginTop: '6px' }}>{value}</Box>
        {hint && <Box sx={{ fontSize: '12.5px', marginTop: '4px', color: dark ? ui.pinkDark : ui.sub }}>{hint}</Box>}
    </Box>
)

// заголовок колонки с сортировкой: ⇅ / ↑ / ↓
export const SortCell: React.FC<{
    label: string
    active: boolean
    dir: 1 | -1
    onClick: () => void
    align?: 'left' | 'center' | 'right'
}> = ({ label, active, dir, onClick, align = 'center' }) => (
    <TableCell align={align} onClick={onClick} sx={{ cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap', color: active ? ui.pink : undefined }}>
        {label} <span style={{ opacity: active ? 1 : 0.4 }}>{active ? (dir > 0 ? '↑' : '↓') : '⇅'}</span>
    </TableCell>
)

export const page = { background: ui.card, border: `1px solid ${ui.border}`, borderRadius: '16px', padding: { xs: '16px', md: '24px' }, minHeight: '80vh' }
export const kpiRow = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 2, marginBottom: '18px' }
export const sub = { color: ui.sub, fontSize: '13.5px' }
export const muted = { color: ui.muted, fontSize: '12px' }
export const tableWrap = { border: `1px solid ${ui.border}`, borderRadius: '14px', overflowX: 'auto' as const }
export const headRow = {
    '& th': { background: ui.surface, fontSize: '12px', fontWeight: 700, color: ui.sub, textTransform: 'uppercase' as const, letterSpacing: '0.03em', padding: '10px 12px' },
}
export const bodyRow = { '& td': { padding: '10px 12px', fontSize: '13.5px', color: ui.ink, borderColor: ui.border } }
export const btn = {
    borderRadius: ui.radius,
    textTransform: 'none' as const,
    fontWeight: 700,
    fontSize: '13px',
    padding: '5px 12px',
    whiteSpace: 'nowrap' as const,
}
